import { Injectable, WritableSignal, signal } from '@angular/core';
import { ProcessTreeNode } from '@em4cloud/process-tree';

@Injectable({
    providedIn: 'root',
})
export class ProcessTreeService {
    isTestViewState: WritableSignal<boolean> = signal(false);

    get isTestView() {
        return this.isTestViewState();
    }

    setIsTestView(view: boolean) {
        this.isTestViewState.set(view);
    }

    /**
     * Reassigns 'wbs' code recursively (including children) for given siblings nodes.
     * It does not change their actual order.
     * It just reorders the wbs sequentially
     *
     * @param nodes
     * @param childIndex - position (code) of the node in the new list of siblings
     * @param offset - the part of the 'wbs' code to change (represents the heirarchy level)
     * @returns the sibling nodes with their children recursively with reordered 'wbs' code
     */
    reorderWbs(nodes: ProcessTreeNode[], childIndex: number, offset = 0): ProcessTreeNode[] {
        nodes.forEach((node, index) => {
            let value = [...node.meta.wbs];
            value.splice(
                node.meta.wbs.length - (1 + offset),
                1,
                (childIndex || index + 1).toString()
            );
            node.meta.wbs = value.join('');
            if (node.children)
                this.reorderWbs(node.children, offset ? childIndex : index + 1, offset + 2);
        });
        return nodes;
    }
}
